import { Password } from "@mui/icons-material";
import { ChangePasswordForm } from "../forms/ChangePasswordForm";
import { SettingsCard } from "../layout/SettingsCard";

const SecuritySettings = () => {
    return (
        <SettingsCard title="Change Password" icon={Password}>
            <ChangePasswordForm />
        </SettingsCard>
    );
};

export default SecuritySettings;
